module.exports = __webpack_public_path__ + "static/img/slip_stehend1.02fb5b7a.png";